import parse from "html-react-parser";
import React, { useState, useEffect } from "react";
import PriceHtml from "../pages/PriceHtml";
import { getFinalPricewithSymbol, getPriceSymbole,getExchangeRate } from "../Helper";
import { Link, useNavigate } from "react-router-dom";
import AddtoWishlist from "../pages/AddtoWishlist";
import { useCart } from "../context/cart";
import { useAuth } from "../context/auth";
import axios from "axios";

const RightPopUpSlider = ({ currentIndex, reel }) => {
  const symbol = getPriceSymbole();
  const exchangeRate = getExchangeRate();
  const navigate = useNavigate();
  const [cart_data] = useCart();
  const [cart, setCart] = useCart();
  const [choiceotions, SetChoiceotions] = useState(false);
  const [finalAmount, setFinalAmount] = useState(0);
  const [shippingtime, Setshippingtime] = useState("");
  const [cartqty, setCartQty] = useState(1);
  const [cartData, SetCartData] = useState([]);
  const [catradded, SetCatradded] = useState(false);
  const [lauth] = useAuth();

  

  const [selectedAttribute, setSelectedAttribute] = useState({});
  const [customMsg, setCustomMsg] = useState(false);

  useEffect(() => {
    setSelectedAttribute({ choice_2: "L" });
    //eslint-disable-next-line
  }, [currentIndex]);


  var choice_options = "";
  var variation = "";
  if (currentIndex !== "undefined") {
    choice_options = JSON.parse(reel?.reels?.[currentIndex]["choice_options"]);
    variation = JSON.parse(reel?.reels?.[currentIndex]["variation"]);
  }  
 

  const handleChangeAttribute = (e) => {
    const cvalue = e.target.value.replace(/\s+/g, "");
    setSelectedAttribute({
      ...selectedAttribute,
      [e.target.name]: cvalue,
    });

    if (variation.length > 0) {
      getVariantPrice();
    }
  };

  let getVariantPrice = (k) => {
    SetCatradded(false);
    var error = true;
    if (error) {
      var selAtt = Object.values(selectedAttribute);
      selAtt = selAtt.join("-");
      var selSize = selAtt;
      var selcolor = reel?.reels?.[currentIndex]["colors_name"];
      if (selcolor) {
        selAtt = selcolor + "-" + selAtt;
      }

      let filtered = [];
      for (let j = 0; j < variation.length; j++) {
        if (selAtt === variation[j].type) {
          filtered.push(variation[j]);
        }
      }
      //console.log(filtered);

      var finalCartPri = finalAmount;
      //return false;
      /*  const filtered = variation.filter(selvar => selvar.sku.includes(selAtt)); */
      if (filtered.length > 0) {
        setFinalAmount(filtered[0].price * cartqty);
        //console.log(filtered[0].shipping_time);
        Setshippingtime(filtered[0].shipping_time);
        if (reel?.reels?.[currentIndex]["discount"] !== 0) {
          finalCartPri = Math.round(
            filtered[0].price -
              ((filtered[0].price * reel?.reels?.[currentIndex]["discount"]) /
                100) *
                cartqty
          );
        } else {
          finalCartPri = filtered[0].price * cartqty;
        }
      }

      var sel_data = {
        ["product_id"]: reel?.reels?.[currentIndex]["id"],
        ["price"]: finalCartPri,
        ["choices"]: selectedAttribute,
        ["variant"]: selAtt,
        ["variations"]: {
          color: reel?.reels?.[currentIndex]["colors_name"],
          Size: selSize,
        },
        ["color"]: JSON.parse(reel?.reels?.[currentIndex]["colors"])[0],
      };
      SetCartData({
        ...cartData,
        ...sel_data,
      });
    }
  };

  let AddToCart = (redirect) => {
    const c_data = {
      ...cartData,
      ["customer_id"]: lauth?.user ? lauth.user.id : 0,
      ["quantity"]: cartqty,
      ["slug"]: reel?.reels?.[currentIndex]["slug"],
      ["name"]: reel?.reels?.[currentIndex]["name"],
      ["thumbnail"]: reel?.reels?.[currentIndex]["thumbnail"],
    };
    SetCartData(c_data);

    const addCarttoDatabase = async (dataArr) => {
      if (dataArr.customer_id != "") {
        let cart_data = {
          id: dataArr.product_id,
          product_id: dataArr.product_id,
          color: dataArr.color,
          choice_2: dataArr.variations.Size,
          quantity: dataArr.quantity,
          customer_id: dataArr.customer_id,
          price_data:{"currency":symbol,"exchange_rate":exchangeRate}
        };

        try {
          let { data } = await axios.post(
            `${process.env.REACT_APP_API_URL}/cart/add`,
            cart_data
          );
          // console.log(data); return false;
          if (data?.status) {
            return data;
          }
        } catch (error) {
          console.log(error);
        }
      }
    };

    //let existingCartItem = localStorage.getItem("cart");
    let existingCartItem = cart
      ? cart
      : JSON.parse(localStorage.getItem("cart"));
    //console.log('cart cc', existingCartItem)
    if (existingCartItem) {
      var exist = false;
      const filtered = existingCartItem.filter((element, index, array) => {
        if (
          String(element.variant) === String(c_data.variant) &&
          element.product_id === c_data.product_id
        ) {
          exist = true;
        }
      });
      if (exist) {
        if (redirect) {
          navigate("/checkout");
        } else {
          alert("Already Added in cart");
        }
      } else {
        existingCartItem = [...existingCartItem, c_data];
        localStorage.setItem("cart", JSON.stringify(existingCartItem));
        setCart(existingCartItem);
        if (redirect) {
          navigate("/checkout");
        }

        SetCatradded(true);
        addCarttoDatabase(c_data);
      }
    } else {
      localStorage.setItem("cart", JSON.stringify([c_data]));
      setCart([c_data]);
      if (redirect) {
        navigate("/checkout");
      }
      SetCatradded(true);
      addCarttoDatabase(c_data);
    }

    //console.log(c_data);
  };

  let activeReadyToShip = (curSize) => {
    //console.log('object',curSize)

    let filtered = [];
    for (let j = 0; j < variation.length; j++) {
      if (curSize === variation[j].type) {
        filtered.push(variation[j]);
        if (variation[j].shipping_time === "Within 7 days") {
          return "rtd-light";
        } else {
          return "";
        }
      }
    }
    //  console.log(filtered)
  };

  const objectInRowByKeys = (value) => {
    const filtered = variation.filter((element) => element.type === value);
    if (filtered.length > 0 && filtered[0].qty < 1) {
      return 1;
    }
    return 0;
  };

  useEffect(() => {
    //console.log(selectedAttribute)
    // console.log(cartData)
    if (variation.length > 0) {
      getVariantPrice();
      // AddToCart();
    }
    //eslint-disable-next-line
  }, [selectedAttribute]);

  useEffect(() => {
    //eslint-disable-next-line
  }, [cart]);

  return (
    <>
      <div className="video-product">
        <div className="video-img video-product-inner">
          {reel?.reels?.[currentIndex]["images"] &&
            JSON.parse(reel?.reels?.[currentIndex]["images"]).map((e, i) => (
              <img
                src={`${process.env.REACT_APP_IMAGE_URL}product/${e}`}
                alt={i + 1}
              />
            ))}
          {}
        </div>
        <div className="video-product-scroll">
          <div className="video-product-name video-product-inner">
            <h2>{reel?.reels?.[currentIndex]["name"]}</h2>
            <div className="sku-box">
              Item Code: {reel?.reels?.[currentIndex]["code"]}
            </div>
          </div>
          <div className="video-product-size video-product-inner">

            {/* 
              {choice_options.length > 0 &&
              JSON.stringify(selectedAttribute)
              }
          */}

            {currentIndex !== "undefined" &&
              choice_options?.length > 0 &&
              choice_options?.map((key, val) => {
                var sortArr = key.options.sort((a, b) => {
                  var sortingArr = [
                    "S",
                    "M",
                    "L",
                    "XL",
                    "2XL",
                    "CUSTOM TAILORED",
                  ];
                  return (
                    sortingArr.indexOf(a.trim()) - sortingArr.indexOf(b.trim())
                  );
                });
                return (
                  <>
                    <h3>Choose {key.title}:</h3>
                    <div className="tab-nav">
                      <ul className="size-box">
                        {key.options &&
                          sortArr?.map((k, i) => {
                            return (
                              <li
                                key={i}
                                className={activeReadyToShip(
                                  reel?.reels?.[currentIndex]["colors_name"] +
                                    "-" +
                                    k.trim()
                                )}
                              >
                                <input
                                  type="radio"
                                  name={key.name}
                                  disabled={
                                    variation?.length > 0 &&
                                    objectInRowByKeys(
                                      reel?.reels?.[currentIndex][
                                        "colors_name"
                                      ] +
                                        "-" +
                                        k.trim().replace(/\s+/g, "")
                                    )
                                  }
                                  id={key.name + "_" + k.trim()}
                                  checked={
                                    selectedAttribute[key.name] ===
                                    k.trim().replace(/\s+/g, "")
                                  }
                                  onChange={handleChangeAttribute}
                                  value={
                                    selectedAttribute[key.name] &&
                                    selectedAttribute[key.name] === k.trim()
                                      ? selectedAttribute[key.name]
                                      : k.trim()
                                  }
                                />
                                <label for={key.name + "_" + k.trim()}>
                                  {k.trim()}
                                </label>
                              </li>
                            );
                          })}
                      </ul>
                    </div>
                  </>
                );
              })}
          </div>

          <div className="price-box video-product-inner">
            {reel?.reels?.[currentIndex]["current_stock"] > 0 && (
              <PriceHtml
                pdata={{
                  discount: reel?.reels?.[currentIndex]["discount"],
                  discount_type: reel?.reels?.[currentIndex]["discount_type"],
                  price: finalAmount
                    ? finalAmount
                    : reel?.reels?.[currentIndex]["unit_price"],
                  symbol: symbol,
                  divclass: "price-box",
                  shipping_time: shippingtime?shippingtime:reel?.reels?.[currentIndex]["shipping_time"],
                  pagefrom: "productDetails",
                  coupon_message: reel?.reels?.[currentIndex]["coupon_message"],
                }}
              />
            )}
          </div>
          {reel?.reels?.[currentIndex]["current_stock"] < 1 && (
            <span className="sold-out-text">SOLD OUT</span>
          )}
          <div className="video-product-description video-product-inner">
            <h3>Description</h3>
            <>
              {reel?.reels?.[currentIndex]["details"] &&
                parse(reel?.reels?.[currentIndex]["details"])}
            </>
          </div>
        </div>
        <div className="add-to-cart-box">
          <div className="add-cart">
            <input
              type="hidden"
              id=""
              className="input-text qty text"
              name="quantity"
              size="4"
              min="1"
              max=""
              step="1"
              placeholder=""
              inputmode="numeric"
              autocomplete="off"
              value="1"
            />
            <Link className="cart-btn outline-btn "
              to={`/product/${reel?.reels?.[currentIndex]["slug"]}`}
              target="_blank"
            >MORE INFO</Link>

            {finalAmount && (
              <button
                type="button"
                onClick={(e) => AddToCart()}
                className={`cart-btn ${catradded ? "added" : ""}`}
                disabled={reel?.reels?.[currentIndex]["current_stock"] < 1}
              >
                ADD TO CART
              </button>
            )}

            <AddtoWishlist p_id={reel?.reels?.[currentIndex]["id"]} />

            {cart_data && cart_data.length > 0 && (
              <Link to="/checkout" target="_blank" className="checkout-cart-btn">
                <i className="fa-solid fa-cart-shopping"></i>
                <span className="cart-count">{`${
                  cart_data ? cart_data.length : "0"
                }`}</span>
              </Link>
            )}
          </div>
        </div>
      </div>

      <div className="video-title">
        <div className="video-thumb">
          <img
            src={`${process.env.REACT_APP_IMAGE_URL}product/thumbnail/${reel?.reels?.[currentIndex]["thumbnail"]}`}
            alt={reel?.reels?.[currentIndex]["thumbnail"]}
          />
        </div>
        <div className="video-heading">
          <span className="v-heading">
            {reel?.reels?.[currentIndex]["name"]}
          </span>
          <span className="v-price">
            {symbol}
            {getFinalPricewithSymbol(
              reel?.reels?.[currentIndex]["discount"],
              reel?.reels?.[currentIndex]["discount_type"],
              reel?.reels?.[currentIndex]["unit_price"]
            )}
          </span>
        </div>
        <div className="video-pordict-link">
          <Link
            to={`/product/${reel?.reels?.[currentIndex]["slug"]}`}
            target="_blank"
          >
            Shop Now
          </Link>
        </div>
      </div>
    </>
  );
};

export default RightPopUpSlider;
